"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const Svg = __importStar(require("react-native-svg"));
exports.default = (props) => (React.createElement(Svg.Svg, Object.assign({}, props, { viewBox: '0 0 24 24' }),
    React.createElement(Svg.G, { "data-name": 'Layer 2' },
        React.createElement(Svg.G, { "data-name": 'keypad' },
            React.createElement(Svg.Rect, { width: '24', height: '24', opacity: '0' }),
            React.createElement(Svg.Path, { d: 'M5 2a3 3 0 1 0 3 3 3 3 0 0 0-3-3z' }),
            React.createElement(Svg.Path, { d: 'M12 2a3 3 0 1 0 3 3 3 3 0 0 0-3-3z' }),
            React.createElement(Svg.Path, { d: 'M19 8a3 3 0 1 0-3-3 3 3 0 0 0 3 3z' }),
            React.createElement(Svg.Path, { d: 'M5 9a3 3 0 1 0 3 3 3 3 0 0 0-3-3z' }),
            React.createElement(Svg.Path, { d: 'M12 9a3 3 0 1 0 3 3 3 3 0 0 0-3-3z' }),
            React.createElement(Svg.Path, { d: 'M19 9a3 3 0 1 0 3 3 3 3 0 0 0-3-3z' }),
            React.createElement(Svg.Path, { d: 'M5 16a3 3 0 1 0 3 3 3 3 0 0 0-3-3z' }),
            React.createElement(Svg.Path, { d: 'M12 16a3 3 0 1 0 3 3 3 3 0 0 0-3-3z' }),
            React.createElement(Svg.Path, { d: 'M19 16a3 3 0 1 0 3 3 3 3 0 0 0-3-3z' })))));
//# sourceMappingURL=Keypad.js.map